import { useSelector } from 'react-redux';
import { selectHasRequeueAlertPermission } from 'app/modules/alerts/selectors';
import { useGetAlert } from 'app/modules/alerts/queries/useGetAlert';
import {
  U21Chip,
  U21ChipProps,
  U21MenuLayout,
} from 'app/shared/u21-ui/components';
import { useCallback, useState } from 'react';
import { IconCircleDashed, IconClipboardList } from '@u21/tabler-icons';
import { RequeueMenuList } from 'app/modules/alerts/components/SideBySide/RequeueMenuList';

interface Props {
  id: number;
  onSuccess?: () => void;
}

export const Requeue = (props: Props) => {
  const { id, onSuccess: onSuccessProp } = props;

  const hasRequeueAlertPermission = useSelector(
    selectHasRequeueAlertPermission,
  );

  const [open, setOpen] = useState(false);

  const { alert } = useGetAlert(id);

  const onSuccess = useCallback(async () => {
    setOpen(false);
    onSuccessProp?.();
  }, [onSuccessProp]);

  if (!alert) {
    return null;
  }

  const chipProps: U21ChipProps = {
    children: alert['queue.title'] || 'No queue',
    color: 'primary',
    icon: alert.queue_id ? <IconClipboardList /> : <IconCircleDashed />,
    variant: 'ghost',
  };

  if (
    !hasRequeueAlertPermission ||
    alert.status === 'CLOSED' ||
    alert.status === 'IN_REVIEW'
  ) {
    return <U21Chip {...chipProps} />;
  }

  return (
    <U21MenuLayout
      onClose={(e) => {
        e.stopPropagation();
        setOpen(false);
      }}
      trigger={<U21Chip {...chipProps} onClick={() => setOpen(true)} />}
      open={open}
    >
      <RequeueMenuList id={id} onSuccess={onSuccess} />
    </U21MenuLayout>
  );
};
